<template>
  <header class="commerce-header">
    <div class="commerce-header__inner">
      <router-link class="commerce-brand" to="/">
        <workbench-cat-logo class="commerce-brand__mark" size="var(--brand-mark-size)" color="var(--commerce-primary)" />
        <span class="commerce-brand__text">AIMason 物联云</span>
      </router-link>

      <div class="commerce-header__actions">
        <button
          class="commerce-button commerce-button--ghost commerce-workbench-button"
          type="button"
          aria-label="AI工作室"
          @click="goWorkbench"
        >
          <span class="commerce-workbench-label commerce-workbench-label--full">AI工作室</span>
          <span class="commerce-workbench-label commerce-workbench-label--short">工作室</span>
        </button>
        <a class="commerce-button commerce-button--ghost" href="https://aimason.xiaowu-iot.com/" target="_blank" rel="noopener noreferrer">官网</a>
        <template v-if="isLoggedIn">
          <button v-if="isSuperAdmin" class="commerce-button commerce-button--ghost" type="button" @click="goTestPlatform">
            测试平台
          </button>
          <button v-if="canOpenConsole" class="commerce-button commerce-button--ghost" type="button" @click="goConsole">
            控制台
          </button>
          <el-popover placement="bottom-end" trigger="click" :append-to-body="false" popper-class="commerce-account-popover">
            <button class="commerce-account-logout" type="button" @click="logout">
              <i class="el-icon-switch-button" aria-hidden="true" />退出登录
            </button>
            <button slot="reference" class="commerce-button commerce-button--ghost" type="button" aria-label="账户菜单">
              <i class="el-icon-user" aria-hidden="true" />{{ username }}
            </button>
          </el-popover>
        </template>
        <template v-else>
          <button class="commerce-button commerce-button--ghost" type="button" @click="goLogin">
            <i class="el-icon-user" aria-hidden="true" />登录
          </button>
        </template>
      </div>
    </div>
  </header>
</template>

<script>
import WorkbenchCatLogo from '@/components/workbench/WorkbenchCatLogo.vue'
const { isPlatformSuperAdmin, isTenantProjectManager } = require('@/utils/roomAccessUi.cjs')
export default {
  name: 'CommerceHeader',
  components: { WorkbenchCatLogo },
  computed: {
    username() {
      const info = this.$store.state.user.userInfo || {}
      return info.username || info.displayName || '用户'
    },
    isLoggedIn() {
      return Boolean(this.$store.state.user.token)
    },
    isSuperAdmin() {
      return isPlatformSuperAdmin(this.$store.state.user || {})
    },
    // 超管：服务器监控控制台；项目级管理员：3D 项目模型页。
    canOpenConsole() {
      const user = this.$store.state.user || {}
      return isPlatformSuperAdmin(user) || isTenantProjectManager(user)
    }
  },
  methods: {
    currentRedirect() {
      const path = this.$route.fullPath
      return path === '/login' || path === '/register' ? '/' : path
    },
    goLogin() {
      this.$router.push({ path: '/login', query: { redirect: this.currentRedirect() } })
    },
    goWorkbench() {
      const href = this.$router.resolve('/workbench').href
      window.open(href, '_blank', 'noopener')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      if (this.$route.path !== '/') this.$router.push('/')
    },
    goConsole() {
      const path = isPlatformSuperAdmin(this.$store.state.user || {}) ? '/console/monitor' : '/building'
      const href = this.$router.resolve(path).href
      window.open(href, '_blank', 'noopener')
    },
    goTestPlatform() {
      if (!this.isSuperAdmin) return
      const href = this.$router.resolve('/test-platform').href
      window.open(href, '_blank', 'noopener')
    }
  }
}
</script>

<style>
.commerce-account-popover { min-width: 110px; padding: 6px; }
.commerce-account-logout { display: flex; align-items: center; gap: 6px; width: 100%; padding: 6px 10px; border: 0; background: transparent; color: var(--commerce-text); font: inherit; font-size: var(--fs-sm); cursor: pointer; }
.commerce-account-logout { text-decoration: none; }
.commerce-account-logout:hover { color: var(--commerce-primary); background: var(--commerce-primary-soft); }
.commerce-header__actions { margin-left: auto; }
.commerce-header__actions .commerce-button { gap: 6px; }
.commerce-header__actions .commerce-button > i { font-size: var(--fs-lg); }
</style>
